import { Injectable, Type } from '@angular/core';
import { filter, Observable, Subject } from 'rxjs';

import { ApplicationEvent } from './application-event.model';

@Injectable()
export class EventService {
  private eventBus: Subject<ApplicationEvent> = new Subject<ApplicationEvent>();

  constructor() {}

  public publish(event: ApplicationEvent) {
    this.eventBus.next(event);
  }

  /**
   *
   * @param eventType class of events the observable should filter
   * @returns an observable which emits all values that are instance of the eventType or are an child class of eventType
   */
  public on<T extends ApplicationEvent>(eventType: Type<T>): Observable<T> {
    return this.eventBus.pipe(filter((event): event is T => event instanceof eventType));
  }
}
